import React from "react";
import { useTranslation } from "react-i18next";
import useStoredPermissions from "./useStoredPermissions";
import { slide as Menu } from "react-burger-menu";

export const SideBar = () => {
  const { t } = useTranslation();
  const permissions = useStoredPermissions() || [];

  return (
    <Menu>
      {permissions.includes("Super User") && (
        <a id="about" className="menu-item nav-link" href="#/main-dashboard">
          {t('nav.clients')}
        </a>
      )}
      {permissions.includes("Read Department") && (
        <a id="departments" className="menu-item nav-link" href="#/departments">
          {t('nav.departments')}
        </a>
      )}
      {permissions.includes("Read User") && (
        <a id="users" className="menu-item nav-link" href="#/users">
          {t('nav.users')}
        </a>
      )}
      {permissions.includes("Read Calendar") && (
        <a id="calendar" className="menu-item nav-link" href="#/calendar">
          {t('nav.routineCreation')}
        </a>
      )}
      {permissions.includes("Reports") && (
        <a id="reports" className="menu-item nav-link" href="#/reports">
          {t('nav.reports')}
        </a>
      )}
      {permissions.includes("Read Notification") && (
        <a
          id="notifications"
          className="menu-item nav-link"
          href="#/notifications"
        >
          {t('nav.notifications')}
        </a>
      )}
      {permissions.includes("Read Video") && (
        <a id="settings" className="menu-item--small nav-link" href="#/videos">
          {t('nav.videos')}
        </a>
      )}
      {permissions.includes("Read Routine") && (
        <a id="contact" className="menu-item nav-link" href="#/rutines">
          {t('nav.routines')}
        </a>
      )}
      <a id="report-problem" className="menu-item nav-link" href="#/report-problem">
        {t('nav.reportProblem')}
      </a>
      {permissions.includes("Reports") && (
        <a id="tickets" className="menu-item nav-link" href="#/tickets">
          {t('nav.tickets')}
        </a>
      )}
    </Menu>
  );
};
